'use client';

import Image from 'next/image';
import type { MouseEvent } from 'react';
import { TrackedAnchor } from '@/components/ancher/tracked-anchor';
import { getVisibleHeaderBottom } from '@/components/header/get-visible-header-bottom';
import { TRACKED_EVENT_POSITION } from '@/constants/gtag';
import scrollArrow from '@images/main/icons/scroll-arrow.svg';
import scrollMouse from '@images/main/icons/scroll-mouse.svg';
import { MAIN_STORY_ID } from './story-section';

export function MainHeroScrollIndicator({ text }: { text: string }) {
  // 실제 href="#main-story" 라 JS 없이도(또는 실패해도) 브라우저 기본 해시 이동이
  // 동작한다 — preventDefault 후에만 헤더 높이 보정 스무스 스크롤로 교체한다.
  const scrollToStory = (e: MouseEvent<HTMLAnchorElement>) => {
    const story = document.getElementById(MAIN_STORY_ID);
    if (!story) return;
    e.preventDefault();
    const headerHeight = getVisibleHeaderBottom();
    const top =
      story.getBoundingClientRect().top + window.scrollY - headerHeight;
    story.focus({ preventScroll: true });
    window.scrollTo({
      top: Math.max(0, top),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'instant'
        : 'smooth',
    });
  };

  return (
    <div className="absolute bottom-10 left-1/2 z-[2] -translate-x-1/2 motion-safe:animate-main-hero-scroll-bounce xl:bottom-[61px]">
      <TrackedAnchor
        href={`#${MAIN_STORY_ID}`}
        label="main-hero_scroll-indicator"
        position={TRACKED_EVENT_POSITION.MAIN_HEADER}
        onClick={scrollToStory}
        className="flex min-h-11 min-w-11 flex-col items-center gap-1 rounded text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white xl:gap-[10px]"
      >
        <Image
          src={scrollMouse}
          alt=""
          width={24}
          height={36}
          className="h-[17px] w-[11px] xl:h-9 xl:w-6"
        />
        <span className="text-[12px] font-semibold leading-normal xl:text-[15px]">
          {text}
        </span>
        <Image
          src={scrollArrow}
          alt=""
          width={24}
          height={12}
          className="h-[6px] w-[12px] rotate-90 xl:h-3 xl:w-6"
        />
      </TrackedAnchor>
    </div>
  );
}
